// Entry point for the React application. Sets up Redux store, handles user authentication from sessionStorage, and renders the App component.
// Author: fabrice.miras@vitecsoftware.com
// Date: 2025-05-20
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import './assets/styles/styles.scss';
import store from './store/_-_-_-_-__-_-_-_-__configureStore';
import * as actions from './store/actions/index';
import { tokenRefreshService } from './felles/TokenRefreshService';

// Initialize token refresh service with the store
tokenRefreshService.initialize(store);

const token = sessionStorage.getItem('token'); // Retrieve JWT token from sessionStorage

// If a token exists, update the Redux store with authentication state and user info
if (token) {
  store.dispatch(actions.updateAutodataUserAuth(true));
  store.dispatch(actions.updateAutodataUserJWT(token));
  store.dispatch(actions.userAutologinToAutodataAuthGet(token, '', true, 0));
  
  // Start the automatic token refresh service (refresh every hour)
  // Started from Auth Saga
  //tokenRefreshService.start();
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Render the App component wrapped with Redux Provider
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);